import { Action } from "redux";

export const LIST_COUNTRIES_FAIL = "LIST_COUNTRIES_FAIL";

export interface ListCountriesFailAction extends Action {
  type: typeof LIST_COUNTRIES_FAIL;
}

export const listCountriesFail = (): ListCountriesFailAction => ({
  type: LIST_COUNTRIES_FAIL,
});
